<script>
import api from '@/command/api'
import apiTool from '@/command/apiTool'
import DrawerForm from '../../../components/DrawerForm'
import TemplateHeaderTable from '../../../components/TemplateHeaderTable'
import { productTypeSpecialtyList } from '@/utils/textFile'
import TableSelectModel from '../../../components/TableSelectModel'

export default {
  name: 'indexCard',
  data() {
    return {
      ...api.command.getState(),
      showTableSelectModel: false,
    }
  },
  mounted() {
    api.command.getList.call(this, {
      url: '/farmYghClientProduct/productPage',
      current: 1,
      paramsValue: {
        yghClientId: this.$route.query.id,
      },
    })
  },
  methods: {
    getHeader() {
      return [
        {
          name: '名称',
          key: 'productName',
          type: 'input',
        },
        {
          name: '',
          key: '',
          type: 'text',
        },
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'id',
          title: 'ID',
          align: 'left',
          sorter: (a, b) => a.id - b.id,
        },
        {
          dataIndex: 'productName',
          title: '商品名称',
          align: 'left',
        },
        {
          dataIndex: 'standardsName',
          title: '规格',
          align: 'left',
        },
        {
          dataIndex: 'yghClientName',
          title: '分类名称',
          align: 'left',
        },
        {
          dataIndex: 'productType',
          title: '商品类型',
          align: 'left',
          customRender: function (text, records) {
            return text ? productTypeSpecialtyList.find((e) => text == e.value).name : ''
          },
          onExport: (text) => {
            text ? productTypeSpecialtyList.find((e) => text == e.value).name : ''
          },
          filters: productTypeSpecialtyList.map((e) => ({
            text: e.name,
            value: e.value,
          })),
          filterMultiple: false,
        },

        {
          dataIndex: 'action',
          title: '操作',
          type: 'buttonGroup',
          align: 'center',
          width: '10%',
          typeData: ({ records }) => {
            return [
              {
                name: '删除',
                type: 'pop',
                popTitle: '确认是否删除吗?',
                onClick: () => {
                  api.command.delPostArr.call(this, {
                    url: '/farmYghClientProduct/deleteBatch',
                    params: {
                      idList: [records.id],
                    },
                  })
                },
              },
            ]
          },
        },
      ]
    },
    getDrawerForm(source, formData) {
      const form = [
        {
          form: [
            {
              name: '新增卡数',
              key: 'num',
              labelAlign: 'right',
              type: 'inputNumber',
              rules: [
                {
                  required: true,
                  type: 'number',
                },
              ],
            },
          ],
        },
      ]
      return form
    },
    getButton() {
      return [
        {
          name: '添加',
          type: 'primary',
          icon: 'plus',
          onClick: () => {
            this.showTableSelectModel = true
          },
        },
      ]
    },
  },
  render() {
    return (
      <div>
        <TemplateHeaderTable
          headerData={this.getHeader()}
          tableColumns={this.getColumns()}
          button={this.getButton()}
          records={this.records}
        />
        <TableSelectModel
          show={this.showTableSelectModel}
          onCancel={() => (this.showTableSelectModel = false)}
          onOk={(selectedRows) => {
            api.command.create.call(this, {
              url: '/farmYghClientProduct/saveBatch',
              params: {
                yghClientId: this.$route.query.id,
                productIds: selectedRows.map((e) => e.id),
              },
            })
            this.showTableSelectModel = false
          }}
        ></TableSelectModel>
      </div>
    )
  },
}
</script>
